export default function EditIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.47287 2.05426H1.99397C1.73035 2.05426 1.47753 2.15899 1.29113 2.34539C1.10472 2.5318 1 2.78462 1 3.04824V10.006C1 10.2696 1.10472 10.5225 1.29113 10.7089C1.47753 10.8953 1.73035 11 1.99397 11H8.95176C9.21538 11 9.4682 10.8953 9.65461 10.7089C9.84101 10.5225 9.94573 10.2696 9.94573 10.006V6.52713M9.20026 1.30879C9.39797 1.11107 9.66613 1 9.94573 1C10.2253 1 10.4935 1.11107 10.6912 1.30879C10.8889 1.5065 11 1.77466 11 2.05426C11 2.33387 10.8889 2.60203 10.6912 2.79974L5.96985 7.5211L3.98191 8.01809L4.4789 6.03015L9.20026 1.30879Z"
        stroke="#333333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
